/** Doctors may edit a saved OPD diagnosis within this window after first save. */
export const DIAGNOSIS_EDIT_WINDOW_MS = 48 * 60 * 60 * 1000;

export function getDiagnosisEditableUntil(createdAt: Date | string): Date {
	const created = typeof createdAt === 'string' ? new Date(createdAt) : createdAt;
	return new Date(created.getTime() + DIAGNOSIS_EDIT_WINDOW_MS);
}

export function isDiagnosisWithinEditWindow(
	createdAt: Date | string | null | undefined,
	now = new Date()
): boolean {
	if (!createdAt) return false;
	return now.getTime() <= getDiagnosisEditableUntil(createdAt).getTime();
}
